import React from "react";
import axios from "axios";
import "../MainPage/SalesTarget.css";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useState } from "react";
import PaginationLink from "../../../../../components/Pagination/Pagination";
import MiniDrawer from "../../../../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import AddSalesTarget from "../AddPage/AddSalesTarget";
import FilterSalesTarget from "../FilterSalesTarget/FilterSalesTarget";
import { useNavigate } from "react-router-dom";
const isAdmin = localStorage.getItem("isAdmin");

const SalesTarget = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const heading = "Sales Target";

  const [userDetailResponse, setUserDetailResponse] = useState([]);
  const [IsAddSalesTarget, setIsAddSalesTarget] = useState(null);
  const [IsFilterSalesTarget, setIsFilterSalesTarget] = useState(null);

  const navigate = useNavigate();

  function nextPage(user_id) {
    navigate("/SalesTargetPerUser", { state: { user_id: user_id } });
  }

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetSalesTargetForAll?currentMonthYear=&months=`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setUserDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  return (
    <div className="d-flex flex-row app">
      <MiniDrawer />
      <div
        className="container-fluid"
        style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
      >
        <div
          className="d-flex flex-column w-100"
          style={{ backgroundColor: "#F4F4F4" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                Sales Target| <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; List</span>
              </h1>
            </div>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA </option>
                <option value="1">DUBAI </option>
              </select>
            </div>
          </div>
          <div>
            <Wrapper className="ViewLeadDetails">
              {/* --------------master top button---------start---------- */}
              <div className="container-fluid" styel={{ marginTop: "3rem" }}>
                <div className="headerButton">
                  <div>
                    <button
                      style={{ height: "53px", width: "101px" }}
                      onClick={() => {
                        setIsFilterSalesTarget((prevState) => !prevState);
                        if (IsAddSalesTarget) {
                          setIsAddSalesTarget(false); // Close Add Target if Filter is opened
                        }
                      }}
                    >
                      <FilterAltOutlinedIcon className="icon" />
                      Filters
                    </button>
                  </div>
                  {isAdmin === "true" && (
                    <div className="button-container">
                      <button
                        onClick={() => {
                          setIsAddSalesTarget((prevState) => !prevState);
                          if (IsFilterSalesTarget) {
                            setIsFilterSalesTarget(false); // Close Filter if Add Target is opened
                          }
                        }}
                      >
                        <DownloadIcon className="icon" />
                        Add Target
                      </button>
                    </div>
                  )}
                </div>
                <hr />
                {IsAddSalesTarget ? <AddSalesTarget /> : null}
                {IsFilterSalesTarget ? (<FilterSalesTarget setUserDetailResponse={setUserDetailResponse} IsFilterSalesTarget={IsFilterSalesTarget} setIsFilterSalesTarget={setIsFilterSalesTarget} />) : null}
                <div>
                  <span style={{ fontSize: "25px" }}>{heading}</span>
                </div>
              </div>
              <div className="container-fluid">
                <div className="SalesTarget">
                  <table>
                    <tr className="SalesTargetHeading">
                      <th rowSpan={2}>S No.</th>
                      <th rowSpan={2}>month</th>
                      <th rowSpan={2}>Name</th>
                      <th rowSpan={2}>Assigned Leads</th>
                      <th colSpan={2}>Target</th>
                      <th colSpan={2}>Target achieved</th>
                      <th rowSpan={2}>Conversion (%)</th>
                      <th rowSpan={2}>Revenue (%)</th>
                      <th rowSpan={2}>Details</th>
                    </tr>
                    <tr className="SalesTargetHeading">
                      <th>Booking</th>
                      <th>Revenue</th>
                      <th>Booking</th>
                      <th>Revenue</th>
                    </tr>
                    {userDetailResponse !== null ? (
                      userDetailResponse.map((user, index) => (
                        <tr key={user.user_id}>
                          <td>{++index}</td>
                          <td>{user.month_name}</td>
                          <td>{user.name}</td>
                          <td>{user.assigned_lead}</td>
                          <td>{user.target_by_lead}</td>
                          <td>{user.target_by_revenue}</td>

                          <td>{user.achieved_by_lead}</td>
                          <td>{user.achieved_by_revenue}</td>

                          <td>{user.conversion}</td>
                          <td>{user.revenue_percentage}</td>
                          <td>
                            <button
                              style={{ height: "30px", width: "38px" }}
                              onClick={() => {
                                nextPage(user.user_id);
                              }}
                            >
                              <SearchIcon className="icon" />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <p>empty</p>
                    )}
                  </table>
                </div>
              </div>
              <PaginationLink />
            </Wrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesTarget;
